import { graphql } from "gql";

// IMPORTANT: when adding additional variables to this query, make sure to add
// them to keyArgs in `src/modules/services/app-graphql-client/app-graphql-client.ts`
// (page and pageSize are exceptions and should not be included, otherwise load more pagination will break)

const SEARCH_MESSAGE_THREADS_QUERY = graphql(`
  query searchMessageThreads($input: SearchInput!) {
    searchMessageThreads(input: $input) {
      ...MessageThreadSearch
    }
  }
`);

export default SEARCH_MESSAGE_THREADS_QUERY;
